import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="reveal"
export default class extends Controller {
  static targets = ['container', 'trigger', 'icon', 'label']
  static values = {
    open: Boolean,
    url: String,
    openIcon: String,
    closeIcon: String,
    openLabel: String,
    closeLabel: String
  }

  connect() {
    this.updateUI()
    this.toggleDebounced = this.debounce(this.toggle.bind(this), 300)
  }

  async toggle(e) {
    e.preventDefault()
    
    this.openValue = !this.openValue
    this.updateUI()

    if (this.hasUrlValue) {
      try {
        const response = await patch(this.urlValue, {
          body: JSON.stringify({ open: this.openValue }),
          contentType: 'application/json'
        })

        if (!response.ok) {
          console.error('Failed to update server state')
          this.openValue = !this.openValue
          this.updateUI()
        }
      } 
      catch (error) {
        console.error('Error while toggling:', error)
        this.openValue = !this.openValue
        this.updateUI()
      }
    }
  }

  updateUI() {
    this.containerTarget.classList.toggle('hide', !this.openValue)

    if (this.hasLabelTarget) {
      this.labelTarget.innerText = this._getLabel(this.openValue)
    }

    if (this.hasIconTarget) {
      this.iconTarget.innerText = this._getIcon(this.openValue)
    }
  }

  _getLabel(isOpen) {
    return isOpen
      ? (this.hasCloseLabelValue ? this.closeLabelValue : 'Close')
      : (this.hasOpenLabelValue ? this.openLabelValue : 'Open')
  }

  _getIcon(isOpen) {
    return isOpen
      ? (this.hasCloseIconValue ? this.closeIconValue : 'expand_less')
      : (this.hasOpenIconValue ? this.openIconValue : 'expand_more')
  }

  debounce(func, wait) {
    let timeout
    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), wait)
    }
  }
}
